<main
  class="container-fluid px-0 irembogov-view-service-change-request mt-n5 pt-1">
  <irembogov-irembo-loading-circle-spinner
    *ngIf="isLoadingChangeRequest"></irembogov-irembo-loading-circle-spinner>

  <ng-container *ngIf="!isLoadingChangeRequest">
    <ng-container *ngIf="loadRequestDetailsFailed">
      <div class="col-8 text-center mx-auto mt-5">
        <irembogov-irembo-section-message
          [type]="'danger'"
          [message]="loadFailedErrorCodeMessage.message"
          title="Error Encountered: {{
            loadFailedErrorCodeMessage.code
          }}"></irembogov-irembo-section-message>
        <a [routerLink]="['/services']">
          &lt;&lt; Back to Change Requests List</a
        >
      </div>
    </ng-container>

    <ng-container *ngIf="!loadRequestDetailsFailed">
      <irembogov-change-request-configuration-header-widget
        [readyForSaveSubmit]="false"
        [request]="changeRequest"
        [inReviewMode]="true"
        (OnPreviewClick)="toggleFormPreview($event)"
        (OnClickRequirementDoc)="
          onViewRequirementDocs()
        "></irembogov-change-request-configuration-header-widget>

      <div class="d-flex justify-content-end px-4 mt-2 gap-2">
        <button
          class="btn btn-sm btn-outline-primary"
          (click)="showDiffView = !showDiffView">
          <i class="fas fa-code-compare me-1"></i>
          {{ showDiffView ? 'Hide JSON Changes' : 'View JSON Changes' }}
        </button>
        <button class="btn btn-sm btn-outline-danger" (click)="onClose()">
          <i class="fas fa-times me-1"></i> Close
        </button>
        <button
          *ngIf="currentConfigStep < viewSteps.length - 1"
          class="btn btn-sm btn-primary"
          (click)="goToNextStep()">
          Next <i class="fas fa-arrow-right ms-1"></i>
        </button>
      </div>

      <ng-container *ngIf="changeRequest">
        <div
          class="mt-5 p-5 container rounded bg-white"
          *ngIf="showFormPreview">
          <irembogov-preview-service-change-request-json-formdata-widget
            class="mx-auto"
            *ngIf="
              changeRequestJsonFormData
            "></irembogov-preview-service-change-request-json-formdata-widget>
        </div>

        <irembogov-configure-service-change-request-stepper
          *ngIf="!showFormPreview"
          orientation="vertical"
          [showIndexInLabel]="false"
          [configSteps]="viewSteps"
          [selectedIndex]="currentConfigStep"
          (selectionChange)="OnStepperChange($event)">
          <cdk-step
            [label]="item.label"
            *ngFor="let item of viewSteps; let index = index"
            [hasError]="viewSteps[index].hasError"
            [completed]="viewSteps[index].isComplete">
            <ng-container
              *ngTemplateOutlet="getCurrentTemplate(index)"></ng-container>
          </cdk-step>
        </irembogov-configure-service-change-request-stepper>
      </ng-container>
    </ng-container>
  </ng-container>
</main>

<ng-template #viewOverview>
  <irembogov-irembo-loading-circle-spinner
    marginTop="8rem"
    *ngIf="
      isLoadingChangeRequestDetails
    "></irembogov-irembo-loading-circle-spinner>

  <irembogov-review-metadata-overview
    *ngIf="!isLoadingChangeRequestDetails && !showDiffView"
    [changeRequest]="changeRequest"></irembogov-review-metadata-overview>

  <div *ngIf="!isLoadingChangeRequestDetails && showDiffView" class="p-3">
    <irembogov-json-diff-viewer
      [oldData]="isServiceUpdate ? activeCrMetadata : null"
      [newData]="changeRequest"
      [loading]="isServiceUpdate && !activeCrDataLoaded"
      [enableLineComment]="false"
      sectionTitle="Overview">
    </irembogov-json-diff-viewer>
  </div>

  <div
    *ngIf="!isLoadingChangeRequestDetails"
    class="d-flex justify-content-end px-4 pb-4 gap-2">
    <button class="btn btn-sm btn-outline-danger" (click)="onClose()">
      <i class="fas fa-times me-1"></i> Close
    </button>
    <button class="btn btn-sm btn-primary" (click)="goToNextStep()">
      Next <i class="fas fa-arrow-right ms-1"></i>
    </button>
  </div>
</ng-template>

<ng-template #viewForm>
  <irembogov-irembo-loading-circle-spinner
    marginTop="8rem"
    *ngIf="
      isLoadingChangeRequestDetails
    "></irembogov-irembo-loading-circle-spinner>

  <irembogov-review-formbuilder-json-editor
    *ngIf="!isLoadingChangeRequestDetails && !showDiffView"
    [changeRequest]="changeRequest"
    [viewOnlyMode]="true">
  </irembogov-review-formbuilder-json-editor>

  <div *ngIf="!isLoadingChangeRequestDetails && showDiffView" class="p-3">
    <irembogov-json-diff-viewer
      [oldData]="isServiceUpdate ? activeCrFormData : null"
      [newData]="changeRequestJsonFormData"
      [loading]="isServiceUpdate && !activeCrDataLoaded"
      [enableLineComment]="false"
      sectionTitle="Form Definition">
    </irembogov-json-diff-viewer>
  </div>

  <div
    *ngIf="!isLoadingChangeRequestDetails"
    class="d-flex justify-content-end px-4 pb-4 gap-2">
    <button class="btn btn-sm btn-outline-danger" (click)="onClose()">
      <i class="fas fa-times me-1"></i> Close
    </button>
    <button class="btn btn-sm btn-primary" (click)="goToNextStep()">
      Next <i class="fas fa-arrow-right ms-1"></i>
    </button>
  </div>
</ng-template>

<ng-template #viewPricing>
  <irembogov-irembo-loading-circle-spinner
    *ngIf="
      isLoadingChangeRequestDetails
    "></irembogov-irembo-loading-circle-spinner>

  <irembogov-review-pricing
    *ngIf="!isLoadingChangeRequestDetails && !showDiffView"
    [pricingData]="serviceChangeRequestPricingData"
    [changeRequest]="changeRequest">
  </irembogov-review-pricing>

  <div *ngIf="!isLoadingChangeRequestDetails && showDiffView" class="p-3">
    <irembogov-json-diff-viewer
      [oldData]="isServiceUpdate ? activeCrPricingData : null"
      [newData]="serviceChangeRequestPricingData"
      [loading]="isServiceUpdate && !activeCrDataLoaded"
      [enableLineComment]="false"
      sectionTitle="Pricing">
    </irembogov-json-diff-viewer>
  </div>

  <div
    *ngIf="!isLoadingChangeRequestDetails"
    class="d-flex justify-content-end px-4 pb-4 gap-2">
    <button class="btn btn-sm btn-outline-danger" (click)="onClose()">
      <i class="fas fa-times me-1"></i> Close
    </button>
    <button class="btn btn-sm btn-primary" (click)="goToNextStep()">
      Next <i class="fas fa-arrow-right ms-1"></i>
    </button>
  </div>
</ng-template>

<ng-template #viewWorkflow>
  <irembogov-irembo-loading-circle-spinner
    marginTop="8rem"
    *ngIf="
      isLoadingChangeRequestDetails
    "></irembogov-irembo-loading-circle-spinner>

  <irembogov-review-workflow-json-entry
    *ngIf="!isLoadingChangeRequestDetails && !showDiffView"
    [changeRequestJsonWorkflow]="changeRequestJsonWorkflowData"
    [changeRequest]="changeRequest">
  </irembogov-review-workflow-json-entry>

  <div *ngIf="!isLoadingChangeRequestDetails && showDiffView" class="p-3">
    <irembogov-json-diff-viewer
      [oldData]="isServiceUpdate ? activeCrWorkflowData : null"
      [newData]="changeRequestJsonWorkflowData"
      [loading]="isServiceUpdate && !activeCrDataLoaded"
      [enableLineComment]="false"
      sectionTitle="Workflow Config">
    </irembogov-json-diff-viewer>
  </div>

  <div
    *ngIf="!isLoadingChangeRequestDetails"
    class="d-flex justify-content-end px-4 pb-4 gap-2">
    <button class="btn btn-sm btn-outline-danger" (click)="onClose()">
      <i class="fas fa-times me-1"></i> Close
    </button>
    <button class="btn btn-sm btn-primary" (click)="goToNextStep()">
      Next <i class="fas fa-arrow-right ms-1"></i>
    </button>
  </div>
</ng-template>

<ng-template #viewTranslation>
  <irembogov-irembo-loading-circle-spinner
    *ngIf="
      isLoadingChangeRequestDetails
    "></irembogov-irembo-loading-circle-spinner>

  <irembogov-review-translations
    *ngIf="!isLoadingChangeRequestDetails && !showDiffView"
    [changeRequest]="changeRequest"
    [translationsData]="serviceChangesRequestTranslations">
  </irembogov-review-translations>

  <div *ngIf="!isLoadingChangeRequestDetails && showDiffView" class="p-3">
    <irembogov-json-diff-viewer
      [oldData]="isServiceUpdate ? activeCrTranslationData : null"
      [newData]="serviceChangesRequestTranslations"
      [loading]="isServiceUpdate && !activeCrDataLoaded"
      [enableLineComment]="false"
      sectionTitle="Translation">
    </irembogov-json-diff-viewer>
  </div>

  <div
    *ngIf="!isLoadingChangeRequestDetails"
    class="d-flex justify-content-end px-4 pb-4 gap-2">
    <button class="btn btn-sm btn-outline-danger" (click)="onClose()">
      <i class="fas fa-times me-1"></i> Close
    </button>
    <button class="btn btn-sm btn-primary" (click)="goToNextStep()">
      Next <i class="fas fa-arrow-right ms-1"></i>
    </button>
  </div>
</ng-template>

<ng-template #viewPreview>
  <irembogov-irembo-loading-circle-spinner
    marginTop="8rem"
    *ngIf="
      isLoadingChangeRequestDetails
    "></irembogov-irembo-loading-circle-spinner>

  <div
    *ngIf="!isLoadingChangeRequestDetails"
    class="w-100 d-flex flex-column p-3">
    <h5 class="d-flex flex-row align-content-center">
      <span class="align-content-center">
        <i class="fa-solid fa-list-check me-2"></i> Preview &amp; Submit
      </span>
    </h5>

    <div class="card bg-white border-0 rounded mt-3">
      <div
        class="text-center justify-contents-center align-items-center flex-column mt-5 px-3 py-5">
        <h5 class="p-3">Configuration view complete</h5>
        <button class="btn btn-primary btn-sm" (click)="onClose()">
          <i class="fas fa-times me-1"></i> Close
        </button>
      </div>
    </div>
  </div>
</ng-template>
